import { userApi } from './apis';
import { convertToQueryString } from '@utils';
import {
  GenericItemsResponseInterface,
  UserEntityInterface,
  UserMetadataResponseInterface,
  UserQueryInterface,
} from '@types';
import { LangEnum } from '@enums';

const ROUTES = {
  getCurrentUser: '/current',
  getUserMetadata: '/metadata',
  getAllUsers: '/',
};

export const getCurrentUser = async (): Promise<UserEntityInterface> => {
  const response = await userApi.get<UserEntityInterface>(ROUTES.getCurrentUser);
  return response.data;
};

export const getUserMetadata = async (): Promise<UserMetadataResponseInterface> => {
  const response = await userApi.get<UserMetadataResponseInterface>(ROUTES.getUserMetadata);
  return response.data;
};

export const getAllUsers = async (
  query: Omit<UserQueryInterface, 'lang'>,
  lang?: LangEnum
): Promise<GenericItemsResponseInterface<UserEntityInterface>> => {
  const response = await userApi.get(ROUTES.getAllUsers + convertToQueryString(query, lang));
  return response.data;
};

export const assignUserRole = async (userId: string, roleId: string): Promise<void> => {
  const response = await userApi.patch(`/${userId}/role/${roleId}`, {});
  return response.data;
};

export const removeUserRole = async (userId: string): Promise<void> => {
  const response = await userApi.delete(`/${userId}/role`);
  return response.data;
};
